// extracted by mini-css-extract-plugin
export default {"blockGrade":"block-grade_blockGrade__O-08J"};